module.exports = __webpack_public_path__ + "img/request-bid.99f40424.png";